import axios from 'axios';
import { apiURL } from '@/config';
import { cartToken } from '@/services/cart';

export async function fetchPaymentMethods() {
    const token = cartToken();
    return await axios.get(`${apiURL}checkout/${token}/payment`, {
        responseType: 'json',
    })
}

export async function fetchShippingMethods() {
    const token = cartToken();
    return await axios.get(`${apiURL}checkout/${token}/shipping`, {
        responseType: 'json',
    })
}

export async function chooseShippingMethod(data) {
    const token = cartToken();
    return await axios.put(`${apiURL}checkout/${token}/shipping/0`, data, {
        responseType: 'json',
    })
}

export async function choosePaymentMethod(data) {
    const token = cartToken();
    return await axios.put(`${apiURL}checkout/${token}/payment/0`, data, {
        responseType: 'json',
    })
}

export async function completeCheckout(data) {
    const token = cartToken();
    return await axios.put(`${apiURL}checkout/${token}/complete`, data, {
        responseType: 'json',
    })
}

export async function checkoutSummary() {
    const token = cartToken();
    return await axios.get(`${apiURL}checkout/${token}`, {
        responseType: 'json',
    })
}

export async function checkoutAddress(data) {
    const token = cartToken();
    return await axios.put(`${apiURL}checkout/${token}/address`, data, {
        responseType: 'json',
    })
}

export async function orderInfo(token) {
    return await axios.get(`${apiURL}orders/${token}`, {
        responseType: 'json',
    })
}

export async function orders() {
    return await axios.get(`${apiURL}orders`, {
        responseType: 'json',
    })
}

export async function paymentInfo(token) {
    return await axios.get(`${apiURL}orders/${token}/payment/status`, {
        responseType: 'json',
    })
}

export async function paymentPath(token) {
    return await axios.get(`${apiURL}orders/${token}/pay`, {
        responseType: 'json',
    })
}
